import React from 'react';
import { Calculator, Droplet, Moon, Pill, Gift } from 'lucide-react';
export function ExtraContent() {
  const scrollToCompra = () => {
    document.getElementById('compra')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  const extras = [{
    icon: Calculator,
    title: 'Calculadora de Proteínas',
    desc: 'Personalizada según tu peso y nivel de juego'
  }, {
    icon: Droplet,
    title: 'Plan de Hidratación',
    desc: 'Calcula tu hidratación óptima pre y post partido'
  }, {
    icon: Moon,
    title: 'Calculadora de Sueño',
    desc: 'Horas ideales para máximo rendimiento'
  }, {
    icon: Pill,
    title: 'Guía de Suplementos',
    desc: 'Cuáles tomar, según evidencia científica'
  }];
  return <section className="w-full bg-[#0a0a0a] py-10 px-4" data-id="element-65">
      <div className="max-w-5xl mx-auto" data-id="element-66">
        <div className="flex items-center justify-center gap-2 mb-3" data-id="element-67">
          <Gift className="w-5 h-5 text-[#C6FF3C]" data-id="element-68" />
          <span className="inline-block px-3 py-1 bg-red-600 text-white font-bold text-xs uppercase rounded-full" data-id="element-69">
            EXTRA si compras HOY
          </span>
        </div>

        <h2 className="headline-font text-2xl md:text-4xl text-center text-white uppercase mb-2" data-id="element-70">
          Contenido Extra <span className="text-[#C6FF3C]" data-id="element-71">Comprando Hoy</span>
        </h2>
        <p className="text-center text-gray-400 text-sm md:text-base mb-6 max-w-2xl mx-auto" data-id="element-72">
          Llevá tu rendimiento al siguiente nivel con herramientas de nutrición
          y descanso para deportistas.
        </p>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-3 mb-5" data-id="element-73">
          {extras.map((item, index) => <div key={index} onClick={scrollToCompra} className="bg-gradient-to-br from-gray-900 to-black border border-[#C6FF3C] rounded-lg p-3 cursor-pointer hover:scale-105 transition-transform duration-300" data-id="element-74">
              <item.icon className="w-7 h-7 text-[#C6FF3C] mb-2" data-id="element-75" />
              <h3 className="text-white font-bold text-sm mb-1 leading-tight" data-id="element-76">
                {item.title}
              </h3>
              <p className="text-gray-400 text-xs leading-snug" data-id="element-77">{item.desc}</p>
            </div>)}
        </div>

        <div className="bg-[#C6FF3C] text-black rounded-lg py-2 px-4 text-center" data-id="element-78">
          <p className="text-sm md:text-base font-bold uppercase" data-id="element-79">
            ⚡ Solo disponible si comprás HOY ⚡
          </p>
        </div>
      </div>
    </section>;
}